import React, { useEffect, useState } from 'react'
import Form from '../component/Form'
import Banner from '../component/Banner'
import { RiInstagramFill } from 'react-icons/ri';
import { FaFacebook } from 'react-icons/fa';
import { Col, Row } from 'antd';
import axios from 'axios';
import Loader from '../component/Loader';
import CallToAction from '../component/CallToAction';

function Contact() {

    const [banner, setBanner] = useState(null);
    const [pageContent, setPageContent] = useState(null);

    const getBanner = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-content/ContactUsPageBanner`);
            setBanner(res.data.data[0])
        } catch (err) {
            console.log('Fetching Banner Content', err)
        }
    }

    const getPageContent = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_URL}api/get-content/ContactUsPage`);
            setPageContent(res.data.data)
        } catch (err) {
            console.log('Fetching Banner Content', err)
        }
    }

    useEffect(() => {
        getBanner();
        getPageContent();
    }, []);

    if (banner === null || pageContent === null) {
        return <Loader />
    }

    return (
        <div>
            <section className="contact">
                <Banner
                    Title={banner.title}
                    secttile={banner.sub_title}
                    dec1={banner.short_details}
                    dec2={banner.details}
                    img={`${process.env.REACT_APP_SITE_IMAGES}${banner.image}`}
                />
                <div className="min-h-screen bg-black text-white flex items-center justify-center">
                    <div className="container mx-auto px-4 py-16">
                        <Row gutter={[32, 32]} align="middle" justify="space-between">
                            <Col xs={24} md={10}>
                                <h1 className="text-[184px] font-bold font-syne bg-[linear-gradient(90deg,_rgba(67,170,214,1)_80%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent">
                                    <span className="font-syne text-[184px] bg-[linear-gradient(90deg,_rgba(67,170,214,1)_80%,_rgba(0,0,0,1)_100%)] bg-clip-text text-transparent">
                                        {pageContent[0].title}
                                    </span>
                                </h1>
                                {/* <div className="mt-6 flex gap-4 text-blue-400 text-xl">
                                    <a href="#"><RiInstagramFill /></a>
                                    <a href="#"><FaFacebook /></a>
                                </div> */}
                            </Col>
                            <Col xs={24} md={14}>
                                <div className="bg-gradient-to-br from-[#1f1f1f] to-[#2b2b2b] backdrop-blur-md p-8 rounded-2xl shadow-lg">
                                    <Form des={pageContent[0].short_details} />
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
                <CallToAction />

            </section>
        </div>
    )
}

export default Contact
